export default "__VITE_ASSET__Bc_NxBb2__"